import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import {
  Paper, Button, TextField, FormControl,
} from '@material-ui/core';
import { planValidationSchema } from '../utils/util';
import Actions from '../actions';

class PlanForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      desc: '',
      days: 0,
      tasks: 0,
      version: 1,
    };
  }

    onSubmit = (e) => {
      e.preventDefault();
      const data = this.state;
      planValidationSchema.validate(data)
        .then(() => {
          return this.props.setPlan(this.state)
            .then(() => {
              alert(`Plan Added Successfully!! \n Data: ${JSON.stringify(data)}`);
              this.props.callBack(this.props.plan);
            });
        })
        .catch((err) => { return alert(err); });
    }

    OnChange = (e) => {
      e.persist();
      this.setState((prevState) => { return { ...prevState, [e.target.name]: e.target.value }; });
    }

    render() {
      return (
        <Paper style={{ width: '500px', padding: '50px' }}>
          <h3 style={{ marginTop: 0 }}>Create Plan</h3>
          <form className="form" onSubmit={(e) => { return this.onSubmit(e); }} autoComplete="off">
            <FormControl fullWidth>
              <TextField id="name" name="name" label="Name" onChange={(e) => { return this.OnChange(e); }} />
            </FormControl>
            <FormControl fullWidth style={{ marginTop: '15px' }}>
              <TextField id="desc" name="desc" label="Description" onChange={(e) => { return this.OnChange(e); }} />
            </FormControl>
            <FormControl fullWidth style={{ marginTop: '15px' }}>
              <TextField id="days" name="days" label="Free Trial Days" onChange={(e) => { return this.OnChange(e); }} />
            </FormControl>
            <FormControl fullWidth style={{ marginTop: '15px' }}>
              <TextField id="version" name="version" label="Version" onChange={(e) => { return this.OnChange(e); }} />
            </FormControl>
            <FormControl fullWidth style={{ marginTop: '50px' }}>
              <Button variant="contained" type="submit" color="primary">Add Plan</Button>
            </FormControl>
          </form>
        </Paper>
      );
    }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

function mapStateToProps(state) {
  return {
    plan: state.plan.data,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PlanForm));
